import { render, staticRenderFns } from "./old-dialog.vue?vue&type=template&id=56f4756d&scoped=true&"
import script from "./old-dialog.vue?vue&type=script&lang=ts&"
export * from "./old-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./old-dialog.vue?vue&type=style&index=0&id=56f4756d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4756d",
  null
  
)

export default component.exports